import Vue from 'vue'
import VueRouter from 'vue-router'
import Search from '../views/company/Search.vue'
import CompanyDetails from '../views/company/companyDetails.vue'
import SearchResults from '../views/search-results.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Search',
    component: Search
  },
  {
    path: '/Search',
    name: 'SearchResults',
    component: SearchResults
  },
  {
    path: '/:alias',
    name: 'CompanyDetail',
    component: CompanyDetails,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
